var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"ab-list-item",class:_vm.align ? `ab-list-item_${_vm.align}` : undefined},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }